// Centralised semantic colour tokens.
// Update here if the design palette ever changes — no need to hunt the codebase.

export const COLOR_PRIMARY      = '#1677ff'; // primary actions, links (light mode)
export const COLOR_PRIMARY_DARK = '#69b1ff'; // primary actions, links (dark mode)
export const COLOR_SUCCESS      = '#52c41a'; // profit, completed, active
export const COLOR_WARNING      = '#faad14'; // pending, on-leave, caution
export const COLOR_ERROR        = '#ff4d4f'; // loss, overdue, error, cancelled
